import React from 'react';

const fmt = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  return d.toLocaleString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
};

export function LabUploadHistory({ uploads, showPatient = false, emptyText = 'No lab reports uploaded yet.' }) {
  if (!uploads?.length) return <p className="text-white/40 text-sm" data-testid="lab-upload-history-empty">{emptyText}</p>;
  return (
    <div className="divide-y divide-white/10" data-testid="lab-upload-history">
      {uploads.map((u) => (
        <div key={u.id} className="py-2.5 flex items-start gap-3 text-sm" data-testid={`lab-upload-${u.id}`}>
          <div className="grid place-items-center w-8 h-8 rounded-lg bg-white/10 text-white/70 shrink-0">
            <i className={`fa-solid ${u.file_type === 'pdf' ? 'fa-file-pdf' : 'fa-image'}`} />
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-white truncate">
              {showPatient && u.patient_name ? <span className="font-medium">{u.patient_name}</span> : <span className="font-medium truncate">{u.filename || 'Lab report'}</span>}
              {showPatient && u.filename ? <span className="text-white/40"> · {u.filename}</span> : null}
            </div>
            <div className="text-xs text-white/50">
              {u.uploaded_by_name || 'Unknown'} · {fmt(u.created_at)}
            </div>
          </div>
          <div className="text-right shrink-0">
            <div className="text-white font-semibold">{u.extracted_count} <span className="text-xs font-normal text-white/50">value{u.extracted_count === 1 ? '' : 's'}</span></div>
            {u.status === 'saved' ? (
              <div className="text-[11px] text-emerald-300"><i className="fa-solid fa-check mr-1" />Saved ({u.saved_count})</div>
            ) : (
              <div className="text-[11px] text-white/40">Not saved</div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
